import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=4952802c&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=4952802c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952802c",
  null
  
)

export default component.exports